/**
 * @desc 创建
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.WarehouseOrganizeRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/fulfilment/warehouseOrganize/addData`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
